import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';

type IndexParams = {
  license: string;
  params: {
    page: number;
    period: Period;
    limit: number;
    license_states: string[];
    type: AgentCompanySTI;
    sort: {
      field: string;
      order: Order;
    };
  };
};

export const index = async (allParams: IndexParams) => {
  const {
    license,
    params: {
      sort: { field, order },
      ...params
    },
  } = allParams;

  return apiClient.get(`/companies/${license}/offices?sort[field]=${field}&sort[order]=${order}`, {
    params,
  });
};
